import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import {
	preloadGetInventorySummary,
	preloadListInventoryLevels,
	preloadListInventoryLocations
} from '@/api/react-query'
import { paginatedSearchWithSort } from '@/utils/route-utilities'

const STOCK_STATUSES = ['IN_STOCK', 'LOW_STOCK', 'OUT_OF_STOCK'] as const

export const Route = createFileRoute('/_authenticated/_general/inventory')({
	validateSearch: paginatedSearchWithSort(['quantityOnHand', 'reorderPoint']).extend({
		lowStockOnly: z.coerce.boolean().optional(),
		inventoryLocationUuid: z.string().optional(),
		stockStatus: z.enum(STOCK_STATUSES).optional()
	}),
	loaderDeps: ({
		search: { limit, offset, q, lowStockOnly, inventoryLocationUuid, stockStatus, sortBy, sortOrder }
	}) => ({
		limit,
		offset,
		q,
		lowStockOnly,
		inventoryLocationUuid,
		stockStatus,
		sortBy,
		sortOrder
	}),
	loader: async ({
		context,
		deps: { limit, offset, q, lowStockOnly, inventoryLocationUuid, stockStatus, sortBy, sortOrder }
	}) => {
		await Promise.all([
			preloadListInventoryLevels(context, {
				query: {
					limit,
					offset,
					q,
					lowStockOnly: lowStockOnly || undefined,
					inventoryLocationUuid,
					stockStatus,
					sortBy,
					sortOrder
				}
			}),
			preloadGetInventorySummary(context, { query: {} }),
			preloadListInventoryLocations(context, { query: { limit: 100, offset: 0 } })
		])
	},
	staticData: {
		crumb: ({ context: { L } }) => L.Inventory.Title()
	}
})
